import JPagination from './JPagination'
export { JPagination }
export default JPagination